import { DownloadSimple, GearSix } from '@phosphor-icons/react';
import { FormattedMessage } from 'react-intl';

import CustomizeOptions from './customizeOptions';

import {
  CUSTOMIZE_SELECTED_OPTION,
  INITIAL_REPORT_OPTIONS,
  INITIAL_SELECTED_OPTION,
} from '../../../../constants/downloadReportOptions';
import { DownloadOptions } from '../../../../interfaces/DownloadOptions';

import { Radio } from '~/components/ui/radio';

interface BuildReportSectionProps {
  selectedValue: string;
  setSelectedValue: React.Dispatch<React.SetStateAction<string>>;
  reportOptions: DownloadOptions;
  setReportOptions: React.Dispatch<React.SetStateAction<DownloadOptions>>;
}

const BuildReportSection = ({
  selectedValue,
  setSelectedValue,
  reportOptions,
  setReportOptions,
}: BuildReportSectionProps) => {
  const ICON_SIZE = 35;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === INITIAL_SELECTED_OPTION) {
      setReportOptions(INITIAL_REPORT_OPTIONS);
    }
    setSelectedValue(event.target.value);
  };
  return (
    <div className='flex-grow p-9'>
      <div className='flex flex-col h-full w-full max-w-3xl gap-4 m-auto items-center'>
        <div className='flex flex-row justify-between items-center w-full border-b pb-4 border-b-gray-200'>
          <div className='flex flex-row items-center gap-4'>
            <DownloadSimple size={ICON_SIZE} />
            <div className='flex flex-col'>
              <h5 className='text-xl font-semibold'>
                <FormattedMessage defaultMessage='Download Full Report' />
              </h5>
              <p className='text-base'>
                <FormattedMessage defaultMessage='Download a comprehensive report of the case' />
              </p>
            </div>
          </div>
          <Radio
            checked={selectedValue === INITIAL_SELECTED_OPTION}
            onChange={handleChange}
            value={INITIAL_SELECTED_OPTION}
            name='radio-buttons'
            color='secondary'
          />
        </div>
        <div className='flex flex-row justify-between items-center w-full'>
          <div className='flex flex-row items-center gap-4'>
            <GearSix size={ICON_SIZE} />
            <div className='flex flex-col'>
              <h5 className='text-xl font-semibold'>
                <FormattedMessage defaultMessage='Customize' />
              </h5>
              <p className='text-base'>
                <FormattedMessage defaultMessage='Only select reports you would like to download' />
              </p>
            </div>
          </div>
          <Radio
            checked={selectedValue === CUSTOMIZE_SELECTED_OPTION}
            onChange={handleChange}
            value={CUSTOMIZE_SELECTED_OPTION}
            name='radio-buttons'
            color='secondary'
          />
        </div>
        {selectedValue === CUSTOMIZE_SELECTED_OPTION && (
          <CustomizeOptions
            options={reportOptions}
            setOptions={setReportOptions}
          />
        )}
      </div>
    </div>
  );
};

export default BuildReportSection;
